import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmComponent } from '../components/partials/confirm/confirm.component';
import { ConfirmModel } from '../models/confirm.model';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  constructor(
    private confirmDialog: MatDialog
  ) {}

  openConfirmDialog(message: string, options?: any) {
    return this.confirmDialog.open(ConfirmComponent, {
      disableClose: false,
      panelClass: 'confirm',
      data: { 
        message: message, 
        icon: 'warning',
        btnConfirm: 'Ok',
        btnDismiss: 'Anuluj',
        ...options 
      },
    });
  }
}
